<template>
  <div>
    <div v-if="isCard" class="slider banner-slider">
      <ebsn-meta
        :target="config"
        path="categoryblocktype_CatalogSlider.TITLE"
        tag="h2"
      />
      <ebsn-meta
        :target="config"
        path="categoryblocktype_CatalogSlider.DESCRIPTION"
        tag="div"
      />
      <swiper :options="swiperOption" ref="swiperRefCard">
        <swiper-slide
          v-for="proposal in customProposals"
          :key="proposal.priority"
        >
          <component
            :is="getProposalModelName(proposal)"
            :proposal="proposal"
            :position="config.templateBlock.codInt"
            :warehousePromoType="
              config?.metaData?.categoryblocktype_CatalogSlider
                ?.WAREHOUSE_PROMO_TYPE
            "
          />
        </swiper-slide>
      </swiper>
      <div
        v-if="
          $ebsn.meta(
            config,
            'categoryblocktype_CatalogSlider.SHOW_BULLETS',
            true
          ) && customProposals.length > 1
        "
        :id="`banner-pagination-${config.categoryBlockId}`"
        class="swiper-pagination"
      ></div>
      <div
        v-if="
          $ebsn.meta(
            config,
            'categoryblocktype_CatalogSlider.SHOW_ARROWS',
            false
          )
        "
        :id="`banner-slider-prev-${config.categoryBlockId}`"
        class="swiper-button-prev"
      ></div>
      <div
        v-if="
          $ebsn.meta(
            config,
            'categoryblocktype_CatalogSlider.SHOW_ARROWS',
            false
          )
        "
        :id="`banner-slider-next-${config.categoryBlockId}`"
        class="swiper-button-next"
      ></div>
    </div>
    <div v-else class="slider banner-slider">
      <ebsn-meta
        :target="config"
        path="categoryblocktype_BannerSlider.TITLE"
        tag="h2"
      />
      <ebsn-meta
        :target="config"
        path="categoryblocktype_BannerSlider.DESCRIPTION"
        tag="div"
      />
      <swiper :options="swiperOption" ref="swiperRef">
        <swiper-slide v-for="proposal in config.proposals" :key="proposal.id">
          <component
            :is="getProposalModelName(proposal)"
            :proposal="proposal"
            :position="config.templateBlock.codInt"
          />
        </swiper-slide>
      </swiper>
      <div
        v-if="
          $ebsn.meta(
            config,
            'categoryblocktype_BannerSlider.SHOW_BULLETS',
            true
          ) && config.proposals.length > 1
        "
        :id="`banner-pagination-${config.categoryBlockId}`"
        class="swiper-pagination"
      ></div>
      <div
        v-if="
          $ebsn.meta(
            config,
            'categoryblocktype_BannerSlider.SHOW_ARROWS',
            false
          ) && config.proposals.length > 1
        "
        :id="`banner-slider-prev-${config.categoryBlockId}`"
        class="swiper-button-prev"
      ></div>
      <div
        v-if="
          $ebsn.meta(
            config,
            'categoryblocktype_BannerSlider.SHOW_ARROWS',
            false
          ) && config.proposals.length > 1
        "
        :id="`banner-slider-next-${config.categoryBlockId}`"
        class="swiper-button-next"
      ></div>
    </div>
  </div>
</template>
<style lang="scss">
.banner-slider {
  .swiper-slide {
    height: auto;
    .proposal-card.v-card {
      height: 100%;
      display: flex;
      flex-direction: column;
    }
  }
  @media #{map-get($display-breakpoints, 'xs-only')} {
    .swiper-button-prev,
    .swiper-button-next {
      display: none;
    }
    // .swiper-pagination {
    // }
  }
  @media #{map-get($display-breakpoints, 'sm-and-up')} {
    // .swiper-button-prev,
    // .swiper-button-next {
    // }
    .swiper-pagination {
      display: none;
    }
  }
}
</style>
<script>
import ProposalImage from "./elements/ProposalImage.vue";
import ProposalCardHorizontal from "./elements/ProposalCardHorizontal.vue";
import ProposalCard from "./elements/ProposalCard.vue";
import ProposalCardOverlay from "./elements/ProposalCardOverlay.vue";
import ProposalButton from "./elements/ProposalButton.vue";
import CatalogCard from "./elements/CatalogCard.vue";

import deliveryReactive from "~/mixins/deliveryReactive";
import categoryBlockType from "./categoryBlockType";
import category from "~/mixins/category";

import { mapActions } from "vuex";

export default {
  name: "BannerSlider",
  props: {
    config: { type: Object, required: true },
    container: { type: Boolean, default: true },
    isCard: { type: Boolean, default: false },
    customProposals: { type: Array, required: false }
  },
  components: {
    ProposalImage,
    ProposalCardHorizontal,
    ProposalCard,
    ProposalCardOverlay,
    ProposalButton,
    CatalogCard
  },
  mixins: [deliveryReactive, categoryBlockType, category],
  data() {
    return {
      swiperDefaultOption: {
        slidesPerView: 1,
        spaceBetween: 20,
        autoplay: true,
        watchOverflow: true,
        loop: false,
        pagination: {
          el: `#banner-pagination-${this.config.categoryBlockId}`,
          clickable: true
        },
        navigation: {
          prevEl: `#banner-slider-prev-${this.config.categoryBlockId}`,
          nextEl: `#banner-slider-next-${this.config.categoryBlockId}`
        }
      }
    };
  },
  methods: {
    ...mapActions({
      reloadCat: "category/loadCategoryTree"
    }),
    reload() {
      if (this.$refs.swiperRef.swiperInstance) {
        this.$refs.swiperRef.swiperInstance.slideTo(0);
      }
      if (this.$refs.swiperRefCard.swiperInstance) {
        this.$refs.swiperRefCard.swiperInstance.slideTo(0);
      }
      if (!this.config.proposals || this.config.proposals.length < 1) {
        this.$emit("hide");
      }
    }
  },
  async created() {
    this.$emit("hide");
  }
};
</script>
